import { put, call } from "redux-saga/effects";
import { 
    SENT_CREATEEMPLOYEREMAIL_SUCESS,SENT_CREATEEMPLOYEREMAIL_FAILED,
    SENT_CREATEEMPLOYEEEMAIL_SUCESS,SENT_CREATEEMPLOYEEEMAIL_FAILED,
    SENT_CREATECASEEMAIL_SUCESS,SENT_CREATECASEEMAIL_FAILED,
    SENT_EMPLOYMENTCREATION_SUCESS,SENT_EMPLOYMENTCREATION_FAILED   
} from "../actions/AddEmail";
import { AddEmailAPI } from "../../utils/api/AddEmailAPI";

export function* employerSetupEmail(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddEmailAPI.employerSetupEmail, request.input);
        yield put({
            type: SENT_CREATEEMPLOYEREMAIL_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SENT_CREATEEMPLOYEREMAIL_FAILED, payload: e.message });
    }
}
export function* employeeAccountCreationEmail(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddEmailAPI.employeeAccountCreationEmail, request.input);
        yield put({
            type: SENT_CREATEEMPLOYEEEMAIL_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SENT_CREATEEMPLOYEEEMAIL_FAILED, payload: e.message });
    }
}
export function* sendCaseCreationEmail(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddEmailAPI.sendCaseCreationEmail, request.input);
        yield put({
            type: SENT_CREATECASEEMAIL_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SENT_CREATECASEEMAIL_FAILED, payload: e.message });
    }
}
export function* employmentCreation(request: any) {

    try {
        const result = yield call(AddEmailAPI.employmentCreation, request.input);
        yield put({
            type: SENT_EMPLOYMENTCREATION_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SENT_EMPLOYMENTCREATION_FAILED, payload: e.message });
    }
}
